import { Link } from "react-router-dom";

// Shown at /books when more than one book is published — a grid of cards,
// each linking to that book's own full landing page at /books/:slug. With
// exactly one published book, BooksHomePage skips this and shows that
// book's landing page directly instead.
export default function BooksCatalog({ books }) {
  return (
    <div className="min-h-screen bg-white px-6 py-16 sm:py-24">
      <div className="mx-auto max-w-5xl text-center">
        <span className="font-heading inline-flex items-center gap-1.5 rounded-full border border-sky-200 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-sky-700 shadow-sm">
          🎁 Free Downloads
        </span>
        <h1 className="font-heading mt-4 text-3xl font-extrabold text-zinc-900 sm:text-4xl">
          Pick a Free Ebook
        </h1>
      </div>

      <div className="mx-auto mt-12 grid max-w-5xl gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {books.map((book) => (
          <Link
            key={book.id}
            to={`/books/${book.slug}`}
            className="group flex flex-col overflow-hidden rounded-2xl border border-zinc-100 bg-white shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
          >
            {book.cover_image_url && (
              <div className="flex items-center justify-center bg-gradient-to-br from-sky-50 to-violet-50 p-6">
                <img
                  src={book.cover_image_url}
                  alt={book.title}
                  className="max-h-56 w-auto transition-transform duration-300 group-hover:scale-105"
                />
              </div>
            )}
            <div className="flex flex-1 flex-col p-5 text-left">
              <span className="text-xs font-semibold uppercase tracking-wide text-sky-600">
                {book.category}
              </span>
              <h2 className="font-heading mt-2 text-lg font-bold text-zinc-900">
                {book.title}
              </h2>
              <p className="mt-2 line-clamp-3 text-sm text-zinc-600">
                {book.subheadline}
              </p>
              <span className="mt-4 text-sm font-semibold text-sky-600 group-hover:underline">
                Get your free copy →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
